import { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import QuotePage from './pages/QuotePage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  const navigate = useNavigate();
  const nav = (path) => {
    const routes = {
      home: '/', services: '/services', about: '/about',
      contact: '/contact', quote: '/quote',
    };
    navigate(routes[path] || '/' + path);
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage navigate={nav} />} />
        <Route path="/services" element={<ServicesPage navigate={nav} />} />
        <Route path="/about" element={<AboutPage navigate={nav} />} />
        <Route path="/contact" element={<ContactPage navigate={nav} />} />
        <Route path="/quote" element={<QuotePage navigate={nav} />} />
      </Routes>
      <Footer />
    </>
  );
}
